import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { label: 'Leaderboard', path: '/insights/leaderboard' },
  { label: 'Game Stats', path: '/insights/games' },
  { label: 'Venues', path: '/insights/venues' },
  { label: 'Settlements', path: '/insights/debts' },
];

export function InsightsSubNav() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div style={{ background: '#e8f5f0', border: '1px solid rgba(0,104,85,0.1)', borderRadius: 16, padding: 8, marginBottom: 12 }}>
      <div style={{ display: 'flex', gap: 6 }}>
        {TABS.map(tab => {
          const active = location.pathname === tab.path;
          return (
            <button
              key={tab.path}
              onClick={() => navigate(tab.path)}
              style={{
                flex: 1,
                textAlign: 'center',
                background: active ? '#006855' : 'transparent',
                color: active ? 'white' : '#6b7280',
                padding: '6px 8px',
                borderRadius: 20,
                fontSize: 11,
                fontWeight: 700,
                border: 'none',
                cursor: 'pointer',
                fontFamily: 'inherit',
              }}
            >
              {tab.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}
